import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  FormControlLabel,
  RadioGroup,
  FormControl,
  Paper,
  TextField,
  TablePagination,
  TableBody,
  tooltipClasses,
  Tooltip,
  Alert,
  Snackbar,
  TableRow,
  TableCell,
  styled,
  TableHead,
  Table,
  CircularProgress,
  Backdrop,
  TableContainer,
  Grid,
  Stack,
  MenuItem,
  Radio,
  ButtonGroup,
  FormLabel,
  // InputLabel,
  // Accordion,
  Select,
  // AccordionDetails,
  // AccordionSummary,
  Typography,
  Chip
} from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import { FiBankList } from 'API/Reports';
import { fetchStates } from 'API/AgentOnboarding/api';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AgreementLink, AgreementList, AgreementStatusCheck, RenewAgreement } from 'API/Agreement/api';

const CustomWidthTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 300
  }
});
const Index = () => {
  const [editValues, setEditValues] = useState({
    agreement_type: 'Distributor',
    date_from: new Date().toISOString().split('T')[0],
    date_to: new Date().toISOString().split('T')[0]
  });
  const [BankList, setBankList] = useState('');
  const [State, setState] = useState('');
  const [ErrorMsg, setErrorMsg] = useState('');
  const [ResList, setResList] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [TotalCount, setTotalCount] = useState([]);
  const [SuccessMsg, setSuccessMsg] = useState('');
  const [filteredList, setFilteredList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selected, setSelected] = useState('Pending');
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z\s]/g, '');
  };

  const handleEditChange = (field, value) => {
    setEditValues((prev) => ({
      ...prev,
      [field]: value
    }));
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
  };
  const refunction = () => {
    setResList([]);
    AgreementList(page + 1, rowsPerPage, editValues, setIsloading, setErrorMsg, setResList, setTotalCount);
  };
  const handlLink = (data) => {
    AgreementLink(data, setIsloading, setSuccessMsg, setErrorMsg, refunction);
  };
  const handlRenew = (data) => {
    RenewAgreement(data, setIsloading, setSuccessMsg, setErrorMsg, refunction);
  };
  const handleCheck = (data) => {
    AgreementStatusCheck(data, setIsloading, setSuccessMsg, setErrorMsg, refunction);
  };
  const handleClear = () => {
    // setResList([]);
    setEditValues({
      agreement_type: 'Distributor',
      date_from: new Date().toISOString().split('T')[0],
      date_to: new Date().toISOString().split('T')[0],
      username: '',
      bankname: '',
      filterstate: 'select',
      filterdistrict: '',
      status: 'select'
    });
    AgreementList(
      page + 1,
      rowsPerPage,
      {
        agreement_type: 'Distributor',
        date_from: new Date().toISOString().split('T')[0],
        date_to: new Date().toISOString().split('T')[0],
        username: '',
        bankname: '',
        filterstate: 'select',
        filterdistrict: '',
        status: 'select'
      },
      setIsloading,
      setErrorMsg,
      setResList,
      setTotalCount
    );
  };
  function formatDateTime(dateString) {
    const date = new Date(dateString);

    // Get the day, month, and year
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    // Get the hours, minutes, and seconds
    // let hours = date.getHours();
    // const minutes = date.getMinutes().toString().padStart(2, '0');
    // const seconds = date.getSeconds().toString().padStart(2, '0');

    // Convert 24-hour format to 12-hour format and determine AM/PM
    // const ampm = hours >= 12 ? 'PM' : 'AM';
    // hours = hours % 12 || 12; // Convert to 12-hour format (0 becomes 12)

    // Pad hours with leading zero if necessary
    // const formattedHours = hours.toString().padStart(2, '0');

    // Format date as DD-MM-YYYY
    const formattedDate = `${day}-${month}-${year}`;

    // Format time as HH:MM:SS AM/PM
    // const formattedTime = `${formattedHours}:${minutes}:${seconds}`;

    // Return the combined date and time string
    return `${formattedDate}`;
  }
  const formattedName = (value) => {
    if (!value) return ''; // Handle null or undefined values

    // Convert to lowercase and capitalize the first letter of each word
    return value
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  useEffect(() => {
    setResList([]);
    AgreementList(page + 1, rowsPerPage, editValues, setIsloading, setErrorMsg, setResList, setTotalCount);
  }, [editValues, page, rowsPerPage]);

  useEffect(() => {
    if (selected === 'Pending') {
      setFilteredList(ResList && ResList.filter((item) => item.agreement_status === null || item.agreement_status === false));
    } else if (selected === 'Expired') {
      setFilteredList(ResList && ResList.filter((item) => item.agreement_agent_link_expiry || item.agreement_admin_link_expiry));
    } else if (selected === 'Existing') {
      setFilteredList(ResList && ResList.filter((item) => item.agreement_ds_sign_status && item.agreement_admin_sign_status));
    }
  }, [selected, ResList]);

  useEffect(() => {
    FiBankList(setBankList);
    fetchStates(setState);
  }, []);

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={SuccessMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccessMsg(false)}
      >
        <Alert onClose={() => setSuccessMsg(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {SuccessMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={ErrorMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setErrorMsg(false)}
      >
        <Alert onClose={() => setErrorMsg(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {ErrorMsg}
        </Alert>
      </Snackbar>
      <SubCard title={`${editValues.agreement_type !== 'Others' ? editValues.agreement_type : ''} Agreement List`}>
        {/* <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
          <Typography variant="h4">Search</Typography>
        </AccordionSummary>
        <AccordionDetails> */}
        <Grid container spacing={1}>
          <Grid item xs={6} sm={4} md={3} lg={2} xl={1.5}>
            <FormControl fullWidth>
              {/* <InputLabel id="demo-simple-select-label">Type of Agreement</InputLabel> */}
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                Type of Agreement
              </Typography>
              <Select
                // label="Type of Agreement"
                size="small"
                name="agreement_type"
                value={editValues.agreement_type ? editValues.agreement_type : 'select'}
                onChange={(e) => handleEditChange('agreement_type', e.target.value)}
              >
                <MenuItem value={'select'} disabled>
                  Select
                </MenuItem>
                <MenuItem value="CSP">CSP</MenuItem>
                <MenuItem value="Agent">Agent</MenuItem>
                <MenuItem value="Distributor">Distributor</MenuItem>
                <MenuItem value="Others">Others</MenuItem>
              </Select>
            </FormControl>{' '}
          </Grid>
          <Grid item xs={6} sm={4} md={3} lg={1.5} xl={1.5}>
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              From Date
            </Typography>
            <TextField
              id="outlined-basic"
              // label="From Date"
              fullWidth
              value={editValues.date_from ? editValues.date_from : ''}
              variant="outlined"
              size="small"
              type="date"
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                max: new Date().toISOString().split('T')[0],
                onKeyDown: (e) => e.preventDefault()
              }}
              onChange={(e) => handleEditChange('date_from', e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={3} lg={1.5} xl={1.5}>
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              To Date
            </Typography>
            <TextField
              id="outlined-basic"
              size="small"
              // label="To Date"
              fullWidth
              value={editValues.date_to ? editValues.date_to : ''}
              variant="outlined"
              inputProps={{
                min: editValues.date_from,
                max: new Date().toISOString().split('T')[0],
                onKeyDown: (e) => e.preventDefault()
              }}
              type="date"
              InputLabelProps={{
                shrink: true
              }}
              onChange={(e) => handleEditChange('date_to', e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={3} lg={2} xl={2}>
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              Name
            </Typography>
            <TextField
              // label="Name"
              size="small"
              fullWidth
              value={editValues.username}
              onInput={handleInput}
              onChange={(e) => handleEditChange('username', e.target.value)}
            />
          </Grid>
          {editValues.agreement_type === 'CSP' ||
            (editValues.agreement_type === 'Agent' && (
              <Grid item xs={6} sm={4} md={3} lg={1.5} xl={1.5}>
                <FormControl fullWidth>
                  {/* <InputLabel id="demo-simple-select-label">Bank name</InputLabel> */}
                  <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                    Bank name
                  </Typography>
                  <Select
                    // label="Bank name"
                    size="small"
                    name="bankname"
                    value={editValues.bankname ? editValues.bankname : 'select'}
                    onChange={(e) => handleEditChange('bankname', e.target.value)}
                  >
                    <MenuItem value={'select'} disabled>
                      Select
                    </MenuItem>
                    {BankList &&
                      BankList.map((bank, index) => (
                        <MenuItem value={bank.Bankname} key={index}>
                          {bank.Bankname.toUpperCase()}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>{' '}
              </Grid>
            ))}

          <Grid item xs={6} sm={4} md={3} lg={2} xl={2}>
            <FormControl fullWidth>
              {/* <InputLabel id="demo-simple-select-label">State</InputLabel> */}
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                State
              </Typography>
              <Select
                // label="State"
                size="small"
                name="filterstate"
                value={editValues.filterstate ? editValues.filterstate : 'select'}
                onChange={(e) => handleEditChange('filterstate', e.target.value)}
              >
                <MenuItem value={'select'} disabled>
                  Select
                </MenuItem>
                {State &&
                  Object.entries(State).map(([key]) => (
                    <MenuItem value={key} key={key}>
                      {key}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>{' '}
          </Grid>
          <Grid item xs={6} sm={4} md={3} lg={2} xl={2}>
            <FormControl fullWidth>
              {/* <InputLabel id="demo-simple-select-label">District</InputLabel> */}
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                District
              </Typography>
              <Select
                // label="District"
                size="small"
                name="filterdistrict"
                value={editValues.filterdistrict ? editValues.filterdistrict : 'select'}
                disabled={!editValues.filterstate || editValues.filterstate === 'select'}
                onChange={(e) => handleEditChange('filterdistrict', e.target.value)}
              >
                <MenuItem value={'select'} disabled>
                  Select
                </MenuItem>
                {editValues.filterstate &&
                  State &&
                  State[editValues.filterstate] &&
                  State[editValues.filterstate].map((item, index) => (
                    <MenuItem value={item} key={index}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>{' '}
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2} xl={2} sx={{ display: 'none' }}>
            <TextField
              label="DS Name"
              size="small"
              fullWidth
              value={editValues.dsname}
              onChange={(e) => handleEditChange('dsname', e.target.value)}
            />
          </Grid>
          <FormControl sx={{ display: 'none' }}>
            <FormLabel id="demo-row-radio-buttons-group-label">Status</FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="status"
              value={editValues.status}
              onChange={(e) => handleEditChange('status', e.target.value)}
            >
              <FormControlLabel value="pending" control={<Radio size="small" />} label="Pending" />
              <FormControlLabel value="approve" control={<Radio size="small" />} label="Approved" />
              <FormControlLabel value="reject" control={<Radio size="small" />} label="Rejected" />
            </RadioGroup>
          </FormControl>
          <Grid item xl={1} md={3} lg={1} sm={4} xs={6} display={'flex'} mt={3} alignItems={'center'}>
            <Box>
              <Button
                sx={{
                  backgroundColor: '#592375',
                  color: '#FFFFFF',
                  ml: 1,
                  mr: 1,
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#592375'
                  }
                }}
                color="secondary"
                onClick={handleClear}
              >
                clear
              </Button>
            </Box>
          </Grid>
        </Grid>
        {/* </SubCard> */}
        {/* </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded> */}
        {/* <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ fontWeight: 'bold' }} aria-controls="panel1-content" id="panel1-header">
          </AccordionSummary> */}
        {/* <Typography variant="h4" pl={2} pt={2}>
          {editValues.agreement_type !== 'Others' && editValues.agreement_type} Agreement List
        </Typography> */}
        <Box sx={{display:'flex',justifyContent:'center'}}>
        <ButtonGroup variant="outlined" fullWidth aria-label="Loading button group" sx={{width:'50%', m: 2, }}>
          {['Pending', 'Existing', 'Expired'].map((status) => (
            <Button
              key={status}
              onClick={() => setSelected(status)}
              color="secondary"
              sx={{backgroundColor: selected === status?'#592375':'#fff','&:hover': {
                    backgroundColor: selected === status?'#592375':''
                  }}}
              variant={selected === status ? 'contained' : 'outlined'}
            >
              {status}
            </Button>
          ))}
        </ButtonGroup>
        </Box>
        {/* <AccordionDetails> */}
        {/* <SubCard title="Agreement"> */}
        {filteredList && filteredList.length && editValues.agreement_type === 'Distributor' ? (
          <Paper sx={{ width: '100%' }}>
            <TableContainer
              sx={{
                maxHeight: 500,
                width: { xl: '1200', lg: '1200', md: '1000' },
                overflowX: 'auto', // Ensure horizontal scrolling
                '&::-webkit-scrollbar': {
                  width: '8px',
                  height: '8px'
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: '#f1f1f1'
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#888',
                  borderRadius: '8px'
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  backgroundColor: '#555'
                }
              }}
            >
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    {/* <TableCell sx={{ width: 80 }}>Request ID</TableCell> */}
                    <TableCell sx={{ width: 80, color: '#592375' }}>DS Name</TableCell>
                    {selected !== 'Pending' && <TableCell sx={{ width: 80, color: '#592375' }}>DS Code</TableCell>}
                    <TableCell sx={{ width: 80, color: '#592375' }}>Document ID</TableCell>
                    <TableCell sx={{ width: 80, color: '#592375' }}>Mobile No.</TableCell>
                    <TableCell sx={{ width: 80, color: '#592375' }}>Email ID</TableCell>
                    <TableCell sx={{ width: 100, color: '#592375' }}>State</TableCell>
                    <TableCell sx={{ width: 80, color: '#592375' }}>District</TableCell>
                    <TableCell sx={{ width: 80, color: '#592375' }}>Agreement Create date</TableCell>
                    {selected !== 'Pending' && <TableCell sx={{ width: 80, color: '#592375' }}>E-Agreement Date</TableCell>}
                    {selected !== 'Pending' && <TableCell sx={{ width: 100, color: '#592375' }}>Expiry Date</TableCell>}
                    {selected !== 'Pending' && <TableCell sx={{ width: 100, color: '#592375' }}>Renew date</TableCell>}
                    <TableCell sx={{ width: 100, color: '#592375' }}>Status</TableCell>
                    {selected === 'Pending' && <TableCell sx={{ width: 100, color: '#592375' }}>E-agreement</TableCell>}
                    {selected !== 'Expired' && <TableCell sx={{ width: 80, color: '#592375' }}>Action</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody size="small">
                  {filteredList &&
                    filteredList.map((row, index) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                          <TableCell>{formattedName(row.ds_name)}</TableCell>
                          {selected !== 'Pending' && <TableCell>demo</TableCell>}
                          <TableCell sx={{ width: 30, maxWidth: 30, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <CustomWidthTooltip placement="bottom-start" title={row.agreement_document_id}>
                              {row.agreement_document_id || '-'}
                            </CustomWidthTooltip>
                          </TableCell>
                          <TableCell>{row.mobile_number}</TableCell>
                          <TableCell sx={{ width: 30, maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <CustomWidthTooltip placement="bottom-start" title={row.email_address}>
                              {row.email_address}
                            </CustomWidthTooltip>
                          </TableCell>
                          <TableCell>{row.state}</TableCell>
                          <TableCell>{row.district}</TableCell>
                          <TableCell>{row.agreement_creation_date !== null ? formatDateTime(row.agreement_creation_date) : '-'}</TableCell>
                          {selected !== 'Pending' && <TableCell>demo</TableCell>}
                          {selected !== 'Pending' && <TableCell>{formatDateTime(row.agreement_expiry_date)}</TableCell>}
                          {selected !== 'Pending' && <TableCell>demo</TableCell>}
                          <TableCell sx={{ width: 100 }}>
                            <Chip
                              size="small"
                              color={
                                row.agreement_ds_sign_status === true && row.agreement_admin_sign_status === true ? 'success' : 'primary'
                              }
                              label={
                                row.agreement_ds_sign_status === false
                                  ? 'DS sign pending '
                                  : row.agreement_admin_sign_status === false
                                  ? 'Admin sign pending'
                                  : row.agreement_ds_sign_status === true && row.agreement_admin_sign_status === true
                                  ? 'Completed'
                                  : row.agreement_agent_link_expiry === true || row.agreement_agent_link_expiry === true
                                  ? 'Expired'
                                  : 'pending'
                              }
                            />
                          </TableCell>
                          {selected === 'Pending' && (
                            <TableCell>
                              <Button
                                size="small"
                                variant="outlined"
                                disabled={row.agreement_ds_sign_status === true && row.agreement_admin_sign_status === true}
                                color="secondary"
                                onClick={() => handleCheck(row)}
                              >
                                {row.agreement_ds_sign_status === true && row.agreement_admin_sign_status === true
                                  ? 'e-sign done'
                                  : 'check'}
                              </Button>
                            </TableCell>
                          )}
                          {selected !== 'Expired' && (
                            <TableCell>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={row.agreement_ds_sign_status === true && row.agreement_admin_sign_status === true}
                                onClick={() => {
                                  if (selected === 'Existing') {
                                    handlRenew(row);
                                  } else {
                                    handlLink(row);
                                  }
                                }}
                                color="secondary"
                              >
                                {selected === 'Existing' ? 'Renew e-Agreement' : row.agreement_creation_date ? 'resend link' : 'send link'}
                              </Button>
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              sx={{ width: '100%' }}
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={TotalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        ) : (
          <Stack justifyContent="center" alignItems="center">
            <Typography mt={5} mb={3} variant="h5">
              No data found
            </Typography>
          </Stack>
        )}
      </SubCard>
      {/* </AccordionDetails>
      </Accordion> */}
    </>
  );
};

export default Index;
